import type { FC, ReactNode } from "react";
import { BriefcaseIcon, MapPinIcon } from "@heroicons/react/24/outline";
import { cn } from "@/lib/cn";
import { IconText } from "./icon-text";

type SummaryCardMetaProps = {
  profession?: ReactNode;
  yearsOfExperience?: number;
  location?: string;
  textClassName?: string;
};

export const SummaryCardMeta: FC<SummaryCardMetaProps> = ({
  profession,
  yearsOfExperience,
  location,
  textClassName,
}) => (
  <>
    {profession && (
      <IconText icon={<BriefcaseIcon className="size-18" />} className={textClassName}>
        {profession}
      </IconText>
    )}
    {yearsOfExperience !== undefined && yearsOfExperience > 0 && (
      <span className={cn("text-neutral-black", textClassName)}>{yearsOfExperience}+ Year of Experience</span>
    )}
    {location && (
      <IconText icon={<MapPinIcon className="size-18" />} className={textClassName}>
        {location}
      </IconText>
    )}
  </>
);
